import xregexp from 'xregexp';
import { ValidationSchema } from '../constants/validation';

// TODO: message as i18n
export const validationReducer = (value: string, schemas: Array<ValidationSchema>): Array<string> => schemas
  .filter((schema) => !(typeof schema.rule === 'string' ? xregexp(schema.rule) : schema.rule).test(value))
  .map((schema) => schema.message);
